import React from 'react';
import Item from './CompletedItem';
import {inject} from 'mobx-react';
import {observe} from 'mobx';
import {ClipLoader} from "react-spinners";
import HttpClient from 'services/HttpClient';
import Pagination from 'blocks/Pagination';
import {WORKSHOP_TYPES} from '../../stores/WorkshopsUrlConstants';

const COMPLETED = '/api/v1/workshops/completed/?page=';
const COMPLETED_SPONSOR = '/api/v1/workshops/iacp_completed/?page=';
const COMPLETED_ACI = '/api/v1/workshops/aci_completed/?page=';

@inject('pagination', 'SponsorStore')
export default class CompletedList extends React.Component {


  state = {items: [], pages: 1, isLoading: false };

  componentWillMount = () => {
    const checkSponsor = this.props.SponsorStore.sponsorId;
    this.props.pagination.setInitialState();
    this.request(checkSponsor);
    this.listener = observe(this.props.pagination, 'currentPage', () => this.request(checkSponsor));
  };

  request = (sponsor) => {
    this.setState({isLoading: true});
    let get_url;
    if (sponsor == 'iacp') {
      get_url = COMPLETED_SPONSOR;
    } else if (sponsor == 'aci') {
      get_url = COMPLETED_ACI;
    } else {
      get_url = COMPLETED;
    }
    const workshop_type = this.props.location.search.replace('?workshop_type=', '');
    const request_workshop_type = workshop_type ? `&workshop_type=${WORKSHOP_TYPES[workshop_type]}` : '';
    new HttpClient().get(COMPLETED + this.props.pagination.currentPage).then(data => {
      this.setState({items: data.body.data.workshops, pages: data.body.data.pages, isLoading: false});
      this.props.pagination.setTotalPages(data.body.data.pages);
    })
  };

  componentWillUnmount = () => {
    this.listener();
  };

  render(){
    return(
      <main className="main-content completed">
        <div className="container-fluid purchased">
          <div className="dashboard row">
            {
              this.state.items.map( el => <Item key={el.id} workshop={el}/>)
            }
            {this.state.isLoading && (
              <div className="spinner-container">
                <ClipLoader color='#00BFFF' loading={this.state.isLoading} size={150} />
              </div>
            )}
          </div>
        <Pagination/>
        </div>
      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/completed_workshops/CompletedList.jsx